import BaseProxy from './BaseProxy';

class Ad extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/posts', parameters);
    }

    async updateField(id, params = {}) {
        return this.submit('patch', `/${id}/updateField`, params);
    }

    async getAll(params = {}) {
        return this.submit('get', '/all', params);
    }
}

export default Ad;



// WEBPACK FOOTER //
// ./src/api/Ad.js